<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="apiLoaded || errorText">
        <div v-if="configs.length === 0">
          <v-btn outlined @click="$router.push('/config/ratings2023')">
            создать конфигурацию
          </v-btn>
        </div>
        <div v-else-if="configs.length > 1">
          Найдено более двух конфигураций рейтинга для периода. Необходимо изменение настроек рейтингования
        </div>
        <div v-if="apiLoaded && configs.length === 1" class="wrap">

          <h3>Рейтинги субъектов Российской Федерации (служб занятости населения, СЗН)</h3>
          <div class="list">
            <div class="report-list">
              <OrgMonitorRating
                  v-for="(rating, ratingIndex) in federal_ratings"
                  :key="'federal_rating_' + ratingIndex"
                  :title="(ratingIndex + 1) + ' ' + rating.title"
                  :period="period"
                  :legend="rating.legend"
                  :config="configs[0]"
                  :report-data-function="rating.dataFunction"
                  :region-and-department-info="regionAndDepartmentInfo"
                  :only-current-region="onlyCurrentRegion"
              ></OrgMonitorRating>
            </div>
          </div>
        </div>
        <div v-else style="height:1000px"></div>
      </div>
    </transition>
    <LoaderDialog :show="showLoaderDialog"></LoaderDialog>
  </div>
</template>

<script>
import LoaderDialog from "@/components/elements/LoaderDialog";
import {
  getRating,
  loadConfigRating,
  setDepartmentsByRegion,
  setPeriod
} from "@/modules/OrgMonitor";
import {loadConfigsByMonitoringType} from "@/modules/Rating2023Config";
import OrgMonitorRating from "@/components/orgmonitor_new/OrgMonitorRating";

export default {
  name: "OrgMonitorRatings",
  components: {OrgMonitorRating, LoaderDialog},
  props: ['regionAndDepartmentInfo', 'period', 'onlyCurrentRegion'],
  watch: {
    regionAndDepartmentInfo: {
      async handler() {
        this.apiLoaded = false;
        await this.initialize();
        this.$forceUpdate();
        this.apiLoaded = true;
      },
      deep: true
    },
    period: {
      async handler() {
        this.apiLoaded = false;
        await this.initialize();
        this.$forceUpdate();
        this.apiLoaded = true;
      }
    }
  },
  data: () => ({
    id: null,
    configId: null,
    configs: [],
    checklistValues: [],
    formData: {},
    parametersTextPartMap: new Map(),
    parametersFilePartMap: new Map(),
    parametersAnswerStatusesPartMap: new Map(),
    parametersControllerNotesPartMap: new Map(),
    apiLoaded: false,
    errorText: null,
    dialog: false,
    editable: false,
    currentValues: true,
    quarter: 1,
    componentKey: 0,
    checkListExportDialog: false,
    exportDialogKey: 0,
    showLoaderDialog: false,
    federal_ratings: [],
  }),

  methods: {
    async downloadRating() {
      this.showLoaderDialog = true;

      let query = {
        headerCells: [
          {
            caption: "Субъект РФ",
            width: 10000,
          },
          {
            caption: "Позиция в рейтинге",
            width: 10000,
          },
          {
            caption: "Значение",
            width: 10000,
          }
        ],
        rows: []
      }
      let regionsCount = this.$cznDepartmentsByRegionList.length
      query.rows = this.$cznDepartmentsByRegionList.map(e => [
        {cellDataType: "STRING", value: e.name},
        {cellDataType: "STRING", value: 1 + " - " + regionsCount},
        {cellDataType: "INTEGER", value: 0},
      ])
      await this.$downloadApi("Рейтинг.xlsx", "/export/xlsx", query, true);
      this.showLoaderDialog = false;
    },

    async loadConfigRating() {
        const config = await loadConfigRating()

        this.federal_ratings = config?.sections.map(section => {
          return {
            id: section.id,
            title: section.name,
            legend: section.legend,
            dataFunction: getRating.bind(null, section.indicators[0]?.id)
          }
        })
    },

    async initialize(){
      let configs = await loadConfigsByMonitoringType('ORG')
      this.configs = configs.filter(e => e.period === this.period)
      setDepartmentsByRegion(this.$cznDepartmentsByRegionList)
      setPeriod(this.period)
      await this.loadConfigRating()
    }
  },

  filters: {
    dateFormat: function (date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {
        timeZone: 'Europe/Moscow',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
      return mdate.toLocaleDateString('ru-RU', options)
    }
  },

  async beforeMount() {
    await this.initialize()
    this.apiLoaded = true;
  },
}
</script>

<style scoped lang="scss">
h1 {
  display: flex;
  align-items: center;

  .badge {
    width: 152px;
    height: 60px;
    background: #E8E8E9;
    border: 1px solid #E8E8E9;
    border-radius: 4px;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 70px;
    color: $cblack;
  }

  .v-progress-circular {
    margin-left: 20px;
  }

  .v-btn {
    margin-left: auto;
  }
}

.manual-link {
  margin: 20px 0;

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-bottom: 20px;

    .v-icon {
      color: #0033a0;
      margin-right: 10px;
    }
  }
}

.list {
  table {
    margin-bottom: 25px;

    th {
      border-bottom: 1px solid #E8E8E9;
    }

    td:nth-child(2),
    th:nth-child(2) {
      text-align: right;
    }

    td > div {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;

      svg {
        margin-right: 8px;
        flex-shrink: 0;
        margin-top: 5px;
      }
    }

    tr:last-child td {
      border-bottom: 1px solid #E8E8E9;
    }
  }
}

.push-right {
  float: right;
  margin-top: 15px;
}

.report-list {
  border-top: 1px solid #e8e8e9;

  .report-list__item {
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e9;
    padding: 5px 0;

    .report-list__title {
      flex: 0 0 calc(100% - 40px);

      .toggleSwitch {
        margin-right: 5px;
      }

      span {
        color: $cblue;
      }

      display: flex;
      flex-flow: row nowrap;
      align-items: center;

    }

    .report-list__download {
      background: url(~@/assets/download.svg) no-repeat center center;
      background-size: contain;
      flex: 0 0 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .report-list__graph {
      width: 400px;
      max-width: 100%;
      height: 200px;
      background: $cgray;
      margin-bottom: 10px;
    }
  }
}

.v-menu__content.menuable__content__active {
  box-shadow: none;
  border: 1px solid #A0A0A0;
  border-radius: 0;

  .downloads {
    border-radius: 0;

    .v-list {
      padding: 0;
      background: #E9E9E9;

      .v-list-item {
        padding: 0;
        min-height: initial;

        .v-list-item__title {
          padding: 4px 8px;
          color: $cblue;
        }
      }
    }
  }
}

</style>
